import { createContext, type ReactNode, useContext, useMemo, useState } from 'react';

type HeaderContextState = {
    setOnLogoClick: React.Dispatch<React.SetStateAction<() => void | null>>;
    onLogoClick: () => void | null;
    link: string | null;
    setLink: React.Dispatch<React.SetStateAction<string | null>>;
};

const HeaderContext = createContext<HeaderContextState | null>(null);

export type HeaderContextManagerProps = {
    children: ReactNode;
};

const HeaderContextManager = ({ children }: HeaderContextManagerProps) => {
    const [onLogoClick, setOnLogoClick] = useState<HeaderContextState['onLogoClick']>(null);
    const [link, setLink] = useState(null);

    const context = useMemo(() => ({ onLogoClick, setOnLogoClick, link, setLink }), [link, onLogoClick]);

    return <HeaderContext.Provider value={context}>{children}</HeaderContext.Provider>;
};

export default HeaderContextManager;

export const useHeaderContext = () => {
    const context = useContext(HeaderContext);

    if (!context) {
        throw new Error('Header Context is missing');
    }

    return context;
};
